<template>
  <div class='weirdo-calendar'>
    <FullCalendar
      schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
      ref="weirdoAppCalendar"
      class='weirdo-app-calendar'
      timeFormat="DD-MMM-YYYY"
      height="parent"
      :locale="locale"
      :defaultDate="Date.now()"
      :allDayDefault="true"
      :header="{
        left: '',
        center: 'title',
        right: 'prev,next today dayGridMonth'
      }"
      :plugins="calendarPlugins"
      :weekends="calendarWeekends"
      :navLinks="true"
      :events="events"
      :viewSkeletonRender="viewSkeletonRender"
      :viewSkeletonDestroy="viewSkeletonDestroy"
      :eventClick="eventClick"
    />
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import listGridPlugin from '@fullcalendar/list'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es'

export default {
  name: 'vue-fullcalendar',
  components: {
    FullCalendar,
  },
  props: {
    event: {
      type: Array|Promise,
      required: true,
    },
    title: {
      tyepe: String,
      required: true,
    },
  },
  data() {
    return {
      events: [],
      calendarWeekends: true,
      calendarPlugins: [
        interactionPlugin,
        dayGridPlugin,
        timeGridPlugin,
        listGridPlugin,
      ],
      calendarEvents: [],
    }
  },
  computed: {
    locale: function () {
      return esLocale
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      const self = this
      if (!Array.isArray(self.event)) {
        self.event.then(response => {
          self.events = response
        })
      } else {
        self.events = event
      }
    })
  },
  methods: {
    _setTitle(info) {
      var titleElement = $('.weirdo-calendar').find('.fc-header-toolbar h2, .fc-header-toolbar h1, .fc-header-toolbar h3')
      titleElement.html(`<strong>${info.view.title}</strong>`)
    },
    viewSkeletonRender(info) {
      this._setTitle(info)
    },
    viewSkeletonDestroy(info) {
      this._setTitle(info)
    },
    eventClick(info) {
      this._setTitle(info)
    },
  },
}
</script>
<style>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

.weirdo-calendar {
  margin: 0 0 3em;
}

.weirdo-app-calendar {
  font-size: 14px;
}
</style>
